"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "amountWithCurrency", {
  enumerable: true,
  get: function get() {
    return _amount_with_currency["default"];
  }
});
Object.defineProperty(exports, "bootstrapPosthogConfig", {
  enumerable: true,
  get: function get() {
    return _posthog.bootstrapPosthogConfig;
  }
});
Object.defineProperty(exports, "buildSharedEventProperties", {
  enumerable: true,
  get: function get() {
    return _event_properties.buildSharedEventProperties;
  }
});
Object.defineProperty(exports, "buildWebPosthogEventProperties", {
  enumerable: true,
  get: function get() {
    return _event_properties.buildWebPosthogEventProperties;
  }
});
Object.defineProperty(exports, "capitalizeFirstLetter", {
  enumerable: true,
  get: function get() {
    return _capitalize_first_letter["default"];
  }
});
Object.defineProperty(exports, "captureLandingCampaignParams", {
  enumerable: true,
  get: function get() {
    return _posthog.captureLandingCampaignParams;
  }
});
Object.defineProperty(exports, "capturePosthogEvent", {
  enumerable: true,
  get: function get() {
    return _posthog.capturePosthogEvent;
  }
});
Object.defineProperty(exports, "cardAnswerFeedback", {
  enumerable: true,
  get: function get() {
    return _card_answer_feedback["default"];
  }
});
Object.defineProperty(exports, "cents", {
  enumerable: true,
  get: function get() {
    return _cents["default"];
  }
});
Object.defineProperty(exports, "compareSubmittedValueWithSolution", {
  enumerable: true,
  get: function get() {
    return _exercise_input_comparison.compareSubmittedValueWithSolution;
  }
});
Object.defineProperty(exports, "createUuid", {
  enumerable: true,
  get: function get() {
    return _create_uuid["default"];
  }
});
Object.defineProperty(exports, "deckCardListExercise", {
  enumerable: true,
  get: function get() {
    return _deck_card_list.deckCardListExercise;
  }
});
Object.defineProperty(exports, "deckCardListText", {
  enumerable: true,
  get: function get() {
    return _deck_card_list.deckCardListText;
  }
});
Object.defineProperty(exports, "deckCardListTypeName", {
  enumerable: true,
  get: function get() {
    return _deck_card_list.deckCardListTypeName;
  }
});
Object.defineProperty(exports, "decrementId", {
  enumerable: true,
  get: function get() {
    return _decrement_id["default"];
  }
});
Object.defineProperty(exports, "deleteAllCookies", {
  enumerable: true,
  get: function get() {
    return _delete_all_cookies["default"];
  }
});
Object.defineProperty(exports, "depixify", {
  enumerable: true,
  get: function get() {
    return _depixify["default"];
  }
});
Object.defineProperty(exports, "detectBrowserSpeed", {
  enumerable: true,
  get: function get() {
    return _detect_browser_speed["default"];
  }
});
Object.defineProperty(exports, "displayTargetTextCorrectedForLanguage", {
  enumerable: true,
  get: function get() {
    return _display_target_text_corrected_for_language["default"];
  }
});
Object.defineProperty(exports, "dollar", {
  enumerable: true,
  get: function get() {
    return _dollar["default"];
  }
});
Object.defineProperty(exports, "emailTypoSuggestion", {
  enumerable: true,
  get: function get() {
    return _email_typo_suggestion["default"];
  }
});
Object.defineProperty(exports, "formatBlankAnswer", {
  enumerable: true,
  get: function get() {
    return _format_blank_answer["default"];
  }
});
Object.defineProperty(exports, "formatComment", {
  enumerable: true,
  get: function get() {
    return _format_comment["default"];
  }
});
Object.defineProperty(exports, "formatFilterTag", {
  enumerable: true,
  get: function get() {
    return _format_filter_tag["default"];
  }
});
Object.defineProperty(exports, "formatNumber", {
  enumerable: true,
  get: function get() {
    return _format_number["default"];
  }
});
Object.defineProperty(exports, "formattedRoundNumber", {
  enumerable: true,
  get: function get() {
    return _formatted_round_number["default"];
  }
});
Object.defineProperty(exports, "getCookieValue", {
  enumerable: true,
  get: function get() {
    return _get_cookie_value["default"];
  }
});
Object.defineProperty(exports, "getMessageFromError", {
  enumerable: true,
  get: function get() {
    return _error_utils.getMessageFromError;
  }
});
Object.defineProperty(exports, "getPosthogSessionId", {
  enumerable: true,
  get: function get() {
    return _posthog.getPosthogSessionId;
  }
});
Object.defineProperty(exports, "getUserMedia", {
  enumerable: true,
  get: function get() {
    return _get_user_media["default"];
  }
});
Object.defineProperty(exports, "getYoutubeEmbedUrl", {
  enumerable: true,
  get: function get() {
    return _get_youtube_embed_url["default"];
  }
});
Object.defineProperty(exports, "incrementId", {
  enumerable: true,
  get: function get() {
    return _increment_id["default"];
  }
});
Object.defineProperty(exports, "initPosthog", {
  enumerable: true,
  get: function get() {
    return _posthog.initPosthog;
  }
});
Object.defineProperty(exports, "isBlank", {
  enumerable: true,
  get: function get() {
    return _is_blank["default"];
  }
});
Object.defineProperty(exports, "isFrontendOnlyEvent", {
  enumerable: true,
  get: function get() {
    return _event_properties.isFrontendOnlyEvent;
  }
});
Object.defineProperty(exports, "isPresent", {
  enumerable: true,
  get: function get() {
    return _is_present["default"];
  }
});
Object.defineProperty(exports, "isTruthy", {
  enumerable: true,
  get: function get() {
    return _is_truthy["default"];
  }
});
Object.defineProperty(exports, "isValidEmail", {
  enumerable: true,
  get: function get() {
    return _is_valid_email["default"];
  }
});
Object.defineProperty(exports, "kFormatter", {
  enumerable: true,
  get: function get() {
    return _k_formatter["default"];
  }
});
Object.defineProperty(exports, "lightenColor", {
  enumerable: true,
  get: function get() {
    return _lighten_color.lightenColor;
  }
});
Object.defineProperty(exports, "loadCss", {
  enumerable: true,
  get: function get() {
    return _load_css["default"];
  }
});
Object.defineProperty(exports, "loadScript", {
  enumerable: true,
  get: function get() {
    return _load_script["default"];
  }
});
Object.defineProperty(exports, "meaningDetailSources", {
  enumerable: true,
  get: function get() {
    return _meaning_synonyms.meaningDetailSources;
  }
});
Object.defineProperty(exports, "meaningSynonymText", {
  enumerable: true,
  get: function get() {
    return _meaning_synonyms.meaningSynonymText;
  }
});
Object.defineProperty(exports, "meaningSynonyms", {
  enumerable: true,
  get: function get() {
    return _meaning_synonyms.meaningSynonyms;
  }
});
Object.defineProperty(exports, "niceJoin", {
  enumerable: true,
  get: function get() {
    return _nice_join.niceJoin;
  }
});
Object.defineProperty(exports, "normalizeCharacters", {
  enumerable: true,
  get: function get() {
    return _normalize_characters["default"];
  }
});
Object.defineProperty(exports, "pixify", {
  enumerable: true,
  get: function get() {
    return _pixify["default"];
  }
});
Object.defineProperty(exports, "referrerOptionButtonHeightForOptions", {
  enumerable: true,
  get: function get() {
    return _referrer_option_grid.referrerOptionButtonHeightForOptions;
  }
});
Object.defineProperty(exports, "referrerOptionButtonHeightForRows", {
  enumerable: true,
  get: function get() {
    return _referrer_option_grid.referrerOptionButtonHeightForRows;
  }
});
Object.defineProperty(exports, "referrerOptionGridRowCount", {
  enumerable: true,
  get: function get() {
    return _referrer_option_grid.referrerOptionGridRowCount;
  }
});
Object.defineProperty(exports, "removeArticleFromText", {
  enumerable: true,
  get: function get() {
    return _remove_article_from_text["default"];
  }
});
Object.defineProperty(exports, "removeCookie", {
  enumerable: true,
  get: function get() {
    return _remove_cookie["default"];
  }
});
Object.defineProperty(exports, "safeParseJson", {
  enumerable: true,
  get: function get() {
    return _json_utils.safeParseJson;
  }
});
Object.defineProperty(exports, "sameWithoutCaseAccentsAndPunctuation", {
  enumerable: true,
  get: function get() {
    return _exercise_input_comparison.sameWithoutCaseAccentsAndPunctuation;
  }
});
Object.defineProperty(exports, "sentryInitializer", {
  enumerable: true,
  get: function get() {
    return _sentry_initializer["default"];
  }
});
Object.defineProperty(exports, "setCookieValue", {
  enumerable: true,
  get: function get() {
    return _set_cookie_value["default"];
  }
});
Object.defineProperty(exports, "setInputCaret", {
  enumerable: true,
  get: function get() {
    return _set_input_caret["default"];
  }
});
Object.defineProperty(exports, "setPosthogTrackingEnabled", {
  enumerable: true,
  get: function get() {
    return _posthog.setPosthogTrackingEnabled;
  }
});
Object.defineProperty(exports, "shouldTrackWebPosthog", {
  enumerable: true,
  get: function get() {
    return _posthog.shouldTrackWebPosthog;
  }
});
Object.defineProperty(exports, "sleep", {
  enumerable: true,
  get: function get() {
    return _sleep["default"];
  }
});
Object.defineProperty(exports, "stripHtmlTags", {
  enumerable: true,
  get: function get() {
    return _strip_html_tags["default"];
  }
});
Object.defineProperty(exports, "syncPosthogUser", {
  enumerable: true,
  get: function get() {
    return _posthog.syncPosthogUser;
  }
});
Object.defineProperty(exports, "toCamelCase", {
  enumerable: true,
  get: function get() {
    return _to_camel_case["default"];
  }
});
Object.defineProperty(exports, "truncateAtWordBoundary", {
  enumerable: true,
  get: function get() {
    return _truncate_at_word_boundary["default"];
  }
});
Object.defineProperty(exports, "underlineWronglyPositionedCharacters", {
  enumerable: true,
  get: function get() {
    return _exercise_input_comparison.underlineWronglyPositionedCharacters;
  }
});
Object.defineProperty(exports, "visitedTabsState", {
  enumerable: true,
  get: function get() {
    return _visited_tabs_state.visitedTabsState;
  }
});
Object.defineProperty(exports, "withoutDigits", {
  enumerable: true,
  get: function get() {
    return _string_utils["default"];
  }
});
var _amount_with_currency = _interopRequireDefault(require("./amount_with_currency"));
var _cents = _interopRequireDefault(require("./cents"));
var _decrement_id = _interopRequireDefault(require("./decrement_id"));
var _delete_all_cookies = _interopRequireDefault(require("./delete_all_cookies"));
var _depixify = _interopRequireDefault(require("./depixify"));
var _dollar = _interopRequireDefault(require("./dollar"));
var _format_comment = _interopRequireDefault(require("./format_comment"));
var _format_number = _interopRequireDefault(require("./format_number"));
var _formatted_round_number = _interopRequireDefault(require("./formatted_round_number"));
var _get_cookie_value = _interopRequireDefault(require("./get_cookie_value"));
var _get_user_media = _interopRequireDefault(require("./get_user_media"));
var _increment_id = _interopRequireDefault(require("./increment_id"));
var _is_blank = _interopRequireDefault(require("./is_blank"));
var _is_present = _interopRequireDefault(require("./is_present"));
var _is_valid_email = _interopRequireDefault(require("./is_valid_email"));
var _k_formatter = _interopRequireDefault(require("./k_formatter"));
var _pixify = _interopRequireDefault(require("./pixify"));
var _remove_article_from_text = _interopRequireDefault(require("./remove_article_from_text"));
var _remove_cookie = _interopRequireDefault(require("./remove_cookie"));
var _set_cookie_value = _interopRequireDefault(require("./set_cookie_value"));
var _set_input_caret = _interopRequireDefault(require("./set_input_caret"));
var _to_camel_case = _interopRequireDefault(require("./to_camel_case"));
var _sentry_initializer = _interopRequireDefault(require("./sentry_initializer"));
var _detect_browser_speed = _interopRequireDefault(require("./detect_browser_speed"));
var _create_uuid = _interopRequireDefault(require("./create_uuid"));
var _is_truthy = _interopRequireDefault(require("./is_truthy"));
var _format_filter_tag = _interopRequireDefault(require("./format_filter_tag"));
var _display_target_text_corrected_for_language = _interopRequireDefault(require("./display_target_text_corrected_for_language"));
var _get_youtube_embed_url = _interopRequireDefault(require("./get_youtube_embed_url"));
var _capitalize_first_letter = _interopRequireDefault(require("./capitalize_first_letter"));
var _load_css = _interopRequireDefault(require("./load_css"));
var _load_script = _interopRequireDefault(require("./load_script"));
var _lighten_color = require("./lighten_color");
var _normalize_characters = _interopRequireDefault(require("./normalize_characters"));
var _strip_html_tags = _interopRequireDefault(require("./strip_html_tags"));
var _sleep = _interopRequireDefault(require("./sleep"));
var _posthog = require("./posthog");
var _event_properties = require("./event_properties");
var _string_utils = _interopRequireDefault(require("./string_utils"));
var _exercise_input_comparison = require("./exercise_input_comparison");
var _error_utils = require("./error_utils");
var _json_utils = require("./json_utils");
var _nice_join = require("./nice_join");
var _referrer_option_grid = require("./referrer_option_grid");
var _truncate_at_word_boundary = _interopRequireDefault(require("./truncate_at_word_boundary"));
var _deck_card_list = require("./deck_card_list");
var _email_typo_suggestion = _interopRequireDefault(require("./email_typo_suggestion"));
var _meaning_synonyms = require("./meaning_synonyms");
var _visited_tabs_state = require("./visited_tabs_state");
var _card_answer_feedback = _interopRequireDefault(require("./card_answer_feedback"));
var _format_blank_answer = _interopRequireDefault(require("./format_blank_answer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }